export default __webpack_public_path__ + "static/media/Imagen-defaultvideo.b2e9a210.png";